import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Space,
  Text,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

export default function AlertModal(props: {
  visible: boolean;
  onClose: () => void;
  title?: string;
  content?: string | JSX.Element;
  onConfirm: () => void;
  confirmButtonName?: string;
}) {
  const { t } = useTranslation();
  const { visible, onClose, title, content, confirmButtonName, onConfirm } =
    props;
  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={visible}
      onClose={onClose}
      size="md"
    >
      <ModalContent width={480}>
        <ModalHeader>{title || ''}</ModalHeader>
        <ModalBody>
          <Text mb="8x" lineHeight="lg">
            {content || ''}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onConfirm}>
            {confirmButtonName
              ? confirmButtonName
              : t('reportCommon.buttons.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
